import client from '@/config/directus.api';
import store from '@/store/index';

/**
 * Clear user data
 *
 */
export function clearUserData() {
  store.commit('auth/CLEAR');
  localStorage.clear();
}

/**
 * Login user
 *
 * @param {object} payload
 * @returns {promise}
 */
export function login(payload) {
  return client
    .login(payload)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}

/**
 * Logout user
 *
 * @returns {promise}
 */
export function logout() {
  return new Promise((resolve, reject) => {
    resolve(client.logout());
  });
}

/**
 * Request password reset
 *
 * @param {string} payload
 * @returns {promise}
 */
export function requestPasswordReset(payload) {
  return client
    .requestPasswordReset(payload)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}

export function register(payload) {
  return client
    .post('custom/register', payload)
    .then(response => {
      return response;
    })
    .catch(err => {
      return err;
    });
}
